import React from "react";
import { DateFormatRenderer, CapitalizeRenderer } from "components/common/ag-grid";
import { Link } from "react-router-dom";
import StatusRenderer from "./StatusRenderer";

export const columnDefs = [
  { 
    headerName: 'ID#',
    field: 'id',
    minWidth: 50,
    width: 50,
    cellRenderer: (params) => {
      return  <Link to={`/request/user-accounts/${params.data.id}`} target="_blank" className="tw-capitalize">{params.value}</Link>
    },
  },
  { 
    headerName: 'First name',
    field: 'first_name',
    minWidth: 100,
    width: 130,
    flex: 0,
    pinned: 'left',
    cellRenderer: (params) => {
      return  <Link to={`/request/user-accounts/${params.data.id}`} target="_blank" className="tw-capitalize">{params.value}</Link>
    },
  },
  { 
    headerName: 'Last name',
    field: 'last_name',
    minWidth: 120,
    cellRenderer: CapitalizeRenderer
  },
  {
    headerName: 'Code',
    field: 'name',
    minWidth: 100
  },
  { 
    headerName: 'Phone',
    field: 'phone_number',
    minWidth: 120,
  },
  { 
    headerName: 'Title',
    field: 'title',
    minWidth: 120,
  },
  { 
    headerName: 'Gender',
    field: 'gender',
    minWidth: 100,
    cellRenderer: params => {
      return <span className="tw-capitalize">{params.value}</span>
    }
  },
  { 
    headerName: 'Onboard date',
    field: 'onboard_date',
    minWidth: 120,
    cellRenderer: DateFormatRenderer
  },
  { 
    headerName: 'Manager',
    field: 'manager.name',
    minWidth: 110,
  },
  { 
    headerName: 'Purpose',
    field: 'purpose',
    minWidth: 200,
    cellRenderer: params => {
      const values = params.value;
      if (Array.isArray(values)) {
        return values.map((value, index) => (
          <ul key={index}>
            <li>{value}</li>
          </ul>
        ));
      }
      return null;
    }
  },
  { 
    headerName: 'Department',
    field: 'department.name',
    minWidth: 150
  },
  { 
    headerName: 'Site',
    field: 'site.name',
    minWidth: 140
  },
 
  { 
    headerName: 'Status',
    field: 'status',
    minWidth: 120,
    cellRenderer: StatusRenderer
  },
  { 
    headerName: 'Closed by',
    field: 'closed_by',
    minWidth: 90
  },
  { 
    headerName: 'Closed date',
    field: 'closed_date',
    minWidth: 120,
    cellRenderer: DateFormatRenderer
  },
  { 
    headerName: 'Submited by',
    field: 'created_by',
    minWidth: 120
  },
  { 
    headerName: 'Submited date',
    field: 'created_date',
    minWidth: 150
  }
];